import { Grid, useMediaQuery, useTheme } from "@material-ui/core";
import { Block, Save } from "@material-ui/icons";
import CommonButton from "app/common/Component/Button/CommonButton";
import PopupForm from "app/common/Component/Popup/PopupForm";
import { useFormikContext } from "formik";
import { observer } from "mobx-react";
import React, { memo, useRef } from "react";
import { useReactToPrint } from "react-to-print";
import TreatmentPrintContent from "./TreatmentPrintContent";
import { useStore } from "app/stores";

function TreatmentPreviewPrintPopup({
  patient,
  handleClose,
  open,
  listSelectedItem,
}) {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));
  const componentRef = useRef();

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
    documentTitle: "In phiếu",
  });
  const { setSelectedItem } =
    useStore().patientManagementStore.serviceRequestItemStore;
  const handleClosePopup = () => {
    setSelectedItem([]); 
    handleClose();
  };
  return (
    <PopupForm
      open={open}
      size="xxl"
      height="75vh"
      handleClose={handleClosePopup}
      title={"In phiếu điều trị"}
      formik={{
        initialValues: {},
        onSubmit: async (values) => {
          console.log("Data", values);
        },
        enableReinitialize: true,
      }}
      action={(values) => {
        return (
          <div className="flex-center gap-1">
            <CommonButton type="submit" onClick={handlePrint}>
              {!isMobile && <Save className="mr-2 " />}
              In phiếu
            </CommonButton>

            <CommonButton className="btn-gray" onClick={handleClosePopup}>
              <Block className="mr-2" /> Đóng
            </CommonButton>
          </div>
        );
      }}
    >
      {({ setFieldValue, values }) => {
        return (
          <>
            <ValueForm
              componentRef={componentRef}
              patient={patient}
              listSelectedItem={listSelectedItem}
            />
          </>
        );
      }}
    </PopupForm>
  );
}

const ValueForm = observer((props) => {
  const { componentRef, patient, listSelectedItem } = props;

  return (
    <>
      <Grid container spacing={1}>
        <Grid
          item
          xs={12}
          className="flex-center"
          style={{ border: "1px dashed black", margin: "5px" }}
        >
          <TreatmentPrintContent
            componentRef={componentRef}
            patient={patient}
            listSelectedItem={listSelectedItem}
          />
        </Grid>
      </Grid>
    </>
  );
});

export default memo(observer(TreatmentPreviewPrintPopup));
